import React from 'react';
import {connect} from "react-redux";
import {
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_APPLIANCES,
  SQFT_APPLIANCES_CAES,
  SQFT_CABINET_APPLIANCES
} from "../../../../constants";
import SqftNavAppliancesItem from "./SqftNavAppliancesItem";
import {hardCodeIsCaesarStone} from "../../../../../../misc/fabricatorHardcode";

const SqftNavAppliances = (props) => {
  const {menuOpened} = props;
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.appliances;
  const appliances = hardCodeIsCaesarStone() ? {...SQFT_APPLIANCES_CAES} : {...SQFT_CABINET_APPLIANCES, ...SQFT_APPLIANCES}
  return (
    <div className={"content side-level2" + (expanded ? " expanded" : "")} data-content="appliances" id="appliances-overlay">
      <div className="content-inner">
        <div className="lightbox-title-block">
          <span className="h7" data-text="sqft.navigation.appliances.title">Select Appliances</span>
        </div>
        <div className="lightbox-button-block">
          <div className="lightbox-cancel-button" data-text="sqft.navigation.overlay.closeButton">Close</div>
        </div>
        <div className="lightbox-options-wrapper" id="appliances-overlay-items">
          {
            Object.keys(appliances).map((itemName, index) =>
              <SqftNavAppliancesItem itemName={itemName} key={index}/>
            )
          }
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => (store.sqftMenuState);

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavAppliances);
